import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Sheet, MetaRow, MetaSpacer, SheetTitle, Body } from './DocumentSurface.styled';

export interface DocumentSurfaceMeta {
  sygnatura?: string | null;
  sad?: string | null;
  data?: string | null;
}

interface DocumentSurfaceProps {
  title: string;
  meta?: DocumentSurfaceMeta;
  children: ReactNode;
  width?: number;
  shadow?: boolean;
}

export default function DocumentSurface({
  title,
  meta,
  children,
  width,
  shadow,
}: DocumentSurfaceProps) {
  const { t } = useTranslation();
  const hasMeta = meta && (meta.sygnatura || meta.sad || meta.data);

  return (
    <Sheet $width={width} $shadow={shadow}>
      {hasMeta ? (
        <MetaRow>
          {meta?.sygnatura ? (
            <span>
              <strong>{t('documents.surface.sygnatura')}:</strong>
              {meta.sygnatura}
            </span>
          ) : null}
          {meta?.sad ? (
            <span>
              <strong>{t('documents.surface.court')}:</strong>
              {meta.sad}
            </span>
          ) : null}
          {meta?.data ? <MetaSpacer>{meta.data}</MetaSpacer> : null}
        </MetaRow>
      ) : null}
      <SheetTitle>{title}</SheetTitle>
      <Body>{children}</Body>
    </Sheet>
  );
}
